import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtCreateUserWinLandingComp from '@/features/userWins/EtCreateUserWinLandingComp'

const EtModalCreateUserWinLanding = ({
  isOpen,
  userId,
  userOrgId,
  onClose = () => {},
  refetchUserWins = () => {}
}) => {

    // First Created: 08 Apr 2025  
    // Author: Atul Pandey  
    // Purpose: Modal wrapper for creating a user win from the landing page


  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-4xl">
        
        {/* Close Button */}
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
        </div>

        {/* Main Win Component */}
        <EtCreateUserWinLandingComp
          userId={userId}
          userOrgId={userOrgId}
          onClose={onClose}
          refetchUserWins={refetchUserWins}
        />
      </div>
    </div>
  )
}

export default EtModalCreateUserWinLanding
